export default __webpack_public_path__ + "static/media/team.006ba71e.jpeg";